import { useLocalSearchParams } from 'expo-router';

import { PublicTenantProfileScreen } from '@/components/profiles/public-tenant-profile-screen';

export default function MemberTenantProfileRoute() {
  const { tenant: tenantSlug } = useLocalSearchParams<{ tenant: string }>();

  return (
    <PublicTenantProfileScreen
      backFallbackHref="/app/me"
      eventHref={(_tenant, event) => ({
        pathname: '/app/events/[id]',
        params: { id: event.id },
      })}
      eventsHref={(tenant) => ({
        pathname: '/app/clubs/[tenant]/events',
        params: { tenant: tenant.slug },
      })}
      tenantSlug={tenantSlug}
    />
  );
}
